import { render } from "./onboarding_ai_panel.html?vue&type=template&id=45585313&external"
import script from "./onboarding_ai_panel.js?vue&type=script&lang=js&external"
export * from "./onboarding_ai_panel.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__